/**
 * 救护车类型
 * @type {{AMBULANCE: {name: string, id: string}, HELICOPTER: {name: string, id: string}}}
 */
export const AMBULANCE_TYPE = {
    AMBULANCE: {name: "救护车", id: "AMBULANCE"},
    HELICOPTER: {name: "直升机", id: "HELICOPTER"}
};
// 订单状态映射
export const NEED_ARRANGE = 'NEED_ARRANGE';// 待安排，待处理

/**
 * 基本的状态
 * @type {*[]}
 */
export const STAFF_ORDER_STATUS = [
    {id: 'NEED_EXAMINE', name: '待审核'},
    {id: NEED_ARRANGE, name: "待处理"},
    {id: "NEED_RECEIVE_AND_SEND", name: "待转运"},
    {id: "IN_TRANSIT", name: "运送中"},
    {id: "NEED_COMMENT", name: "待评价"},
    {id: "ALREADY_COMMENT", name: "已评价"},
    {id: "CANCEL", name: "已取消"}
];

/**
 * 待申请
 * @description 远程会诊-发起-增加该状态
 * @type {{name: string, id: string}}
 */
export const NEED_APPLICATION = {id: 'NEED_APPLICATION', name: '待申请'};

/**
 * 审核管理员展示的状态
 * @type {*[]}
 */
export const STAFF_ORDER_STATUS_FOR_E = [
    {id: 'NEED_EXAMINE', name: '待审核'},
    {id: "NEED_ARRANGE", name: "已同意"},
    {id: "CANCEL", name: "已取消"},
    {id: "NEED_RECEIVE_AND_SEND,IN_TRANSIT", name: "进行中"},
    {id: "NEED_COMMENT,ALREADY_COMMENT", name: "已完成"},
];


export const NEED_ISSUE = {id: "NEED_ISSUE", name: "申请"};
export const EXAMINE_HANDLE = {id: "EXAMINE_HANDLE", name: "审核处理"}
export const GO_TO_HOSPITAL = {id: "GO_TO_HOSPITAL", name: "到院收住"}
/**
 * 进度条各个进度
 * @type {[{name: string, id: string},{name: string, id: string},{name: string, id: string},{name: string, id: string},{name: string, id: string},null]}
 */
export const STAFF_PROCEDURE_STATUS = [
    {...NEED_ISSUE},
    {...EXAMINE_HANDLE},
    {id: "HANDLE", name: "转诊处理"},
    {id: "AMBULANCE_SET_OUT", name: "救护车出发"},
    {id: "PATIENT_HANDOVER", name: "患者已送出"},
    {...GO_TO_HOSPITAL}
];

export const STAFF_ADD_ORDER_FIELDS = [
    /*patName	String	患者姓名
  patIdcard	String	患者证件号
  familyContactsName String	患者联系人
  familyContactsMobile String	联系手机号
  docName	String	联系医生
  docMobile String	医生手机
  patComplaint	String	疾病主诉
  tentativeDiagnosis String	诊断
  treatmentProcess String	关键病情经过
  hopeHosId String	申请转入医院
  hopeTime long	意向转诊时间，unix时间戳
  hopeDispatchingCarType String 意向运送安排 急救派车方类型
  hopeTransportRequirement String	意向运送要求
  referralRequirement String	转诊要求
  attaIdList	List<String>	附件列表*/
    "patName",
    "initDocName",
    "initDocMobile",
    "patIdcard",
    "familyContactsName",
    "familyContactsMobile",
    "patComplaint",
    "tentativeDiagnosis",
    "treatmentProcess",
    "hopeHosId",
    "hopeDispatchingCarType",
    "referralRequirement",
    "hopeTransportRequirement",
    "id",
    'transferHospital',
    'consultAvatar',
    'consultAvatarUrl',
    'consultId'
];

export const STAFF_ADD_DRIVER_FIELDS = [
    "staffName",
    "userMobile",
    "staffIdcard",
    "id"
];

export const STAFF_ADD_CAR_FIELDS = [
    "ambulanceType",
    "licensePlateNo",
    "ambulanceName",
    "id"
];

export const STAFF_ADD_RECORD_FIELDS = [
    "emergencyReferralOrderId", "treatmentProcess", "loggingTime", "attaIdList", 'id', 'heartRate', 'bloodPressure', 'bloodPressureLower', 'bloodPressureUpper', 'oxygenSaturation', 'respiratoryRate'
];

export const HOPEDISPATCHINGCARTYPE = [
    {id: "SUB_HOSPITAL_AMBULANCE", name: "下级医院派车接送"},
    {id: "THIRD_PARTY_AMBULANCE", name: "第三方派车接送"},
    {id: "OTHER_WAYS", name: "其它方式"},
    {id: "SUPERIOR_HOSPITAL_AMBULANCE", name: "上级医院派车接送"},
    // {id: "SUPERIOR_HOSPITAL_HELICOPTER", name: "上级医院直升机接送"},
];
/**
 *
 * @type {{init: string, accept: string}}
 */
export const ASPECTUSER = {
    init: "init",
    accept: "accept"
};

/**
 *
 * @type {{DICSONTINUE: {name: string, id: string}, START_USING: {name: string, id: string}}}
 */
export const STAFF_DRIVER_STATUS = {
    DICSONTINUE: {id: "DISCONTINUE", name: "停用"},
    START_USING: {id: "START_USING", name: "启用"}
};
/**
 * 推送类型
 * @type {*[]}
 */
export const INTOVIDEOPUSHTYPE = [
    {id: 'callSuperiors', name: '上级医院', enabled: ['init']},
    {id: 'callSubordinates', name: '下级医院', enabled: ['accept']},
    {id: 'ambulance', name: '救护车', enabled: ['init', 'accept']},
    {id: 'tripartite', name: '三方', enabled: ['init', 'accept']},
];

/**
 *
 * @type {*[]}
 */
export const STAFF_ADD_IN_OUT_FORM_FIELDS = [
    "emergencyReferralOrderId", "applicationType", "initDeptName", "initContactPerson", "initTelephone", "acceptDeptName", "acceptContatPerson", "acceptTelephone", "transhipmentProcessIllnessDesc", "vitalSignsTemperature", "vitalSignsPulse", "vitalSignsRespire", "vitalSignsBloodPressure", "vitalSignsSpo2", "painScore", "gcsOpenEyesScore", "ggcsLanguageScore", "ggcsLimbsScore", "easePainStatus", "easePainMedicine", "pupillaLeftSize", "pupillaLeftLightReflexStatus", "pupillaRightSize", "pupillaRightLightReflexStatus2", "noArtificialAirwaySelectStatus", "noArtificialAirwaySafeSelectStatus", "noArtificialAirwayNeedAttentionSelectStatus", "trachealIntubationSelectStatus", "trachealIntubationDepth", "tracheostomySelectStatus", "venousCatheterSelectStatus", "venousCatheterSelectDesc", "ductusArteriosusSelectStatus", "ductusArteriosusSelectDesc", "vasoactiveDrugsSelectStatus", "vasoactiveDrugsSelectDesc", "cyclicFunctionOthersSelectStatus", "cyclicFunctionOthersSelectDesc", "abdominalContour", "intestinalSounds", "tendernessPainSelectStatus", "tendernessPainSelectDesc", "spinalInjuriesSelectStatus", "spinalInjuriesSelectDesc", "spinalFixationSelectStatus", "spinalFixationSelectDesc", "limbFracturesSelectStatus", "limbFracturesSelectDesc", "limbInjuriesSelectStatus", "limbInjuriesSelectDesc", "bloodVesselSelectStatus", "bloodVesselSelectDesc", "nerveSelectStatus", "nerveSelectDesc", "catheterSelectStatus", "catheterSelectDesc", "drainageTubeSelectStatus", "drainageTubeSelectDesc", "conduitSelectStatus", "conduitSelectDesc", "mattersNeedingAttention", "handDutyName", "handDutyTime", "takeDutyName", "takeDutyTime", 'vitalSignsBloodPressureUpper', 'vitalSignsBloodPressureLower', 'pupillaRightLightReflex', 'pupillaLeftLightReflex'
];

export const sync_in_out_form_field = ['tentativeDiagnosis', 'transhipmentProcessIllnessDesc', 'noArtificialAirwaySelectStatus', 'noArtificialAirwaySafeSelectStatus', 'noArtificialAirwayNeedAttentionSelectStatus',
    'trachealIntubationSelectStatus',
    'trachealIntubationDepth',
    'tracheostomySelectStatus',
    'venousCatheterSelectStatus',
    'venousCatheterSelectDesc',
    'ductusArteriosusSelectStatus',
    'ductusArteriosusSelectDesc',
    'vasoactiveDrugsSelectStatus',
    'vasoactiveDrugsSelectDesc',
    'cyclicFunctionOthersSelectStatus',
    'cyclicFunctionOthersSelectDesc',
    'abdominalContour',
    'intestinalSounds',
    'tendernessPainSelectStatus',
    'tendernessPainSelectDesc',
    'spinalInjuriesSelectStatus',
    'spinalInjuriesSelectDesc',
    'spinalFixationSelectStatus',
    'spinalFixationSelectDesc',
    'limbFracturesSelectStatus',
    'limbFracturesSelectDesc',
    'limbInjuriesSelectStatus',
    'limbInjuriesSelectDesc',
    'bloodVesselSelectStatus',
    'bloodVesselSelectDesc',
    'nerveSelectStatus',
    'nerveSelectDesc',
    'catheterSelectStatus',
    'catheterSelectDesc',
    'drainageTubeSelectStatus',
    'drainageTubeSelectDesc',
    'conduitSelectStatus',
    'conduitSelectDesc',
    'mattersNeedingAttention'];

export const PG_FORM_DATA = {
    '意识评估': {
        id: 'awarenessAssessment',
        value: '',
        data: ['A反应敏捷', 'V对声音刺激有反应', 'P对疼痛刺激有反应', 'U无意识']
    },
    '预检分级': {
        id: 'preInspectionClassification',
        value: '',
        data: ['I级', 'II级', 'III级', 'IVa级', 'IVb级']
    },
    '创伤': {
        id: 'trauma',
        value: '',
        data: ['是', '否']
    },
    '疼痛评分': {
        id: 'painScore',
        data: ['无痛', '有点痛', '轻微疼痛', '疼痛明显', '疼痛严重', '剧烈痛']
    },
    '给氧方式': {
        id: 'provisionsMode',
        value: '',
        data: ['鼻塞', '面罩', '储氧面罩', '气切面罩', '套管内'],
        extra: [{
            pre: '',
            label: '呼吸皮囊辅助呼吸',
            suf: 'L/min',
            width: '60px',
            field: 'provisionsModeSupplement'
        }]
    },
    '呼吸机模式': {
        id: 'ventilatorMode',
        value: '',
        data: ['IPPV/AC', 'SIMV', 'BIPAP', 'PSV/PASB', '无创']
    },
    //急性心肌梗死
    '心电图诊断': {
        id: 'electrocardiogramDiagnosis',
        data: ['正常心电图', '房早', '室早', '房颤', '房扑', '是颤', '室上速', '室速', '房室传导阻滞'],
        extra: [{
            pre: '',
            label: '其他',
            suf: '',
            width: '600px',
            field: 'provisionsModeSupplement'
        }]
    },
    '房室传导阻滞': {
        id: 'ww',
        data: ['Ⅰ°', 'Ⅱ°', 'Ⅲ°'],
    },
    '血液状态监测': {
        id: 'bloodConditionMonitoring',
        data: ['心肌酶谱', 'POCT', '床旁血气分析'],
    },
    '心血管风险评估': {
        id: 'cardiovascularRiskAssessment',
        data: ['收缩压≥180mmhg', '舒张压≥110mmhg', '吸烟≥30支/天']
    },
    //小儿
    '生长发育评测': {
        id: 'growthAndDevelopmentEvaluation',
        data: ['胎儿期', '新生儿期', '婴儿期', '幼儿期', '室上速', '房室传导阻滞']
    },
    '神经心理发育评测': {
        id: 'neuropsychologicalDevelopmentAssessment',
        data: ['感知', '运动', '语言']
    },
    //烧伤
    '烧伤程度': {
        id: 'degreeOfBurn',
        data: ['轻度烧伤（Ⅱ°面积＜9%）', '中度烧伤（Ⅱ°面积为10%~29%或Ⅲ°面积不足10%）', '重度烧伤（总烧伤面积达30%~49%或Ⅲ°面积达10%~19%）', '特重烧伤（总烧伤面积＞50%或Ⅲ°＞20%）']
    },
    //创伤
    '创伤原因': {
        id: 'causesOfTrauma',
        data: ['高处坠落', '交通事故', '重物压伤', '机器搅伤', '刀刺伤', '躯干穿透伤'],
        extra: [{
            pre: '',
            label: '其他',
            suf: '',
            field: 'causesOfTraumaSupplement'
        }]
    },
    '受伤时间': {
        id: 'injuryTime',
        extra: [{
            field: 'injuryTime',
            pre: '',
            label: '受伤时间',
            suf: ''
        }]
    },
    'c意识评估': [
        {id: 'eyesOpen', value: '睁眼反应', data: ['4自主', '3声音刺激', '2疼痛刺激', '1无']},
        {id: 'speechResponse', value: '言语反应', data: ['5定向良好', '4嗜睡', '3答非所问', '2不能理解', '1无']}, {
            id: 'activityResponse', value: '活动反应',
            data: ['6活动自如', '5定位疼痛', '4躲避疼痛', '3痛刺激屈曲', '2痛刺激伸张', '1无']
        },
    ],
    '创伤评估': [
        {id: 'traumaAssessmentAirway', value: '气道', data: ['通畅', '不通畅']},
        {id: 'traumaAssessmentBreathing', value: '呼吸', data: ['正常', '急促', '费力', '表浅', '喘息', '无']},
        {id: 'traumaAssessmentLoop', value: '循环', data: ['颈动脉搏动可触及', '颈动脉搏动']},
        {id: 'traumaAssessmentHead', value: '头', data: ['正常', '挫裂伤', '其它']},
        {id: 'traumaAssessmentNeck', value: '颈', data: ['正常', '疼痛', '其它']}, {
            id: 'traumaAssessmentChest', value: '胸',
            data: ['正常', '膨胀', '对称', '不对称', '肺呼吸音正常', '肺呼吸音不正常', '肿胀', '皮下气肿', '疼痛', '其它']
        }, {id: 'traumaAssessmentAbdomen', value: '腹部', data: ['正常', '膨胀', '疼痛', '肿胀', '其它']}, {
            id: 'traumaAssessmentPelvis', value: '骨盆',
            data: ['正常', '稳定', '不稳定', '疼痛', '肿胀', '可见出血', '其他']
        }, {
            id: 'traumaAssessmentMuscleAndBone',
            value: '肌肉与骨骼',
            data: ['正常', '膨胀', '畸形', '无力', '麻木', '其他']
        }, {id: 'traumaAssessmentBack', value: '后背', data: ['正常', '肿胀', '疼痛', '其它']},
    ],
    '输血信息': {
        id: 'transfusionInformation',
        data: ['红细胞', '血浆', '血小板', '洗涤红细胞', '全血']
    },
    //卒中
    'NIHSS': [{
        id: 'levelOfConsciousness',
        value: '意识水平',
        data: ['0=清醒，反应敏锐', '1=嗜睡', '2=昏睡或反应迟钝', '3=仅有反射活动或自发反应，或完全没反应']
    }, {
        id: 'awarenessLevelQuestioning', value: '意识水平提问',
        data: ['0=都准确', '1=正确回答一个', '2=两个都不准确']
    }, {
        id: 'consciousnessLevelInstruction',
        value: '意识水平指令',
        data: ['0=都准确', '1=正确回答一个', '2=两个都不准确']
    }, {
        id: 'gaze', value: '注视',
        data: ['0=正常', '1=部分凝视麻痹', '2=被动凝视或完全凝视麻痹']
    }, {id: 'emergencyView', value: '视野', data: ['0=无视野缺失', '1=部分盲', '2=完全偏盲', '3=双侧偏盲']}, {
        id: 'facialParalysis', value: '面瘫',
        data: ['0=正常', '1=轻度偏瘫', '2=部分', '3=完全']
    }, {
        id: 'upperLimbMovement', value: '上肢运动',
        data: ['0=上肢要求位置坚持10秒，无下落', '1=上肢能抬起，但不能维持10秒，下落时不能撞击床或其他支持物', '2=能对抗一些重力，但升值不能达到或维持作为90°，或位仰45°，轻快下落', '3=不能对抗中路，上肢快速下落', '4=无运动']
    }, {
        id: 'lowerLimbMovement', value: '下肢运动',
        data: ['0=于要求位置坚持5秒，不下降', '1=在5秒下落，不撞击床', '2=5秒内轻快下落到床上，但可部分抗重力', '3=快速落下，不能抗重力', '4=无运动']
    }, {id: 'totalMaladjustment', value: '共计失调', data: ['0=没有', '1=一个肢体有', '2=两个肢体有']}, {
        id: 'feel', value: '感觉',
        data: ['0=正常', '1=轻到中度', '2=严重到完全感觉丧失']
    }, {id: 'emergencyLanguage', value: '语言', data: ['0=正常', '1=轻到中度', '2=严重失语', '3=缄默或完全失语']}, {
        id: 'dysarthria', value: '构音障碍',
        data: ['0=正常', '1=轻到中度', '2=重度，难以理解', '其他=气管插管或其他物理障碍']
    }, {id: 'neglect', value: '忽视症', data: ['0=没有', '1=视、触、听、空间觉或对个人的忽视', '2=严重的偏身忽视']}, {
        id: 'ultrasonicDopplerBlood',
        value: '超声多普勒血流速度检测',
        data: ['正常', '不正常']
    },]
}

export const PG_FORM_FIELDS = {
    'vitalSignsBloodPressureUpper': 'vitalSignsBloodPressureUpper',
    'vitalSignsBloodPressureLower': 'vitalSignsBloodPressureLower',
    'vitalSignsHeartRate': 'vitalSignsHeartRate',
    'vitalSignsSpo2': 'vitalSignsSpo2',
    'vitalSignsRespire': 'vitalSignsRespire',
    'vitalSignsTemperature': 'vitalSignsTemperature',
    'awarenessAssessment': 'awarenessAssessment',
    'ventilatorTidalVolume': 'ventilatorTidalVolume',
    'ventilatorFrequency': 'ventilatorFrequency',
    'ventilatorInspiratory': 'ventilatorInspiratory',
    'ventilatorExpiratory': 'ventilatorExpiratory',
    'ventilatorPeep': 'ventilatorPeep',
    'ventilatorOxygenConcentration': 'ventilatorOxygenConcentration',
    'ventilatorAirwayPressure': 'ventilatorAirwayPressure',
    'medicationPlavix': 'medicationPlavix',
    'medicationBelinda': 'medicationBelinda',
    'medicationAspirin': 'medicationAspirin',
    'medicationLipitor': 'medicationLipitor',
    'medicationNephroticSyndrome': 'medicationNephroticSyndrome',
    'medicationGlycerylTrinitrate': 'medicationGlycerylTrinitrate',
    'medicationIvVp': 'medicationIvVp',
    'nihssScoringRiskAssessment': 'nihssScoringRiskAssessment',
    'medicationRtPa': 'medicationRtPa',
    'totalDoseInOneMinute': 'totalDoseInOneMinute'
}

export const PG_TABLE_FIELDS = {
    '预检系统评估': [
        {
            label: '生命体征', field: [
                {pre: 'RP:', suf: 'mmhg', field: ['vitalSignsBloodPressureUpper', 'vitalSignsBloodPressureLower']},
                {pre: 'HR:', suf: '次/分', field: 'vitalSignsHeartRate'},
                {pre: 'Spo2:', suf: '%', field: 'vitalSignsSpo2'},
                {pre: 'R:', suf: '次/分', field: 'vitalSignsRespire'},
                {pre: '体温:', suf: '℃', field: 'vitalSignsTemperature'},
            ]
        },
        {
            label: '意识评估<br/><span style="font-size: 12px; color: #999;">(AVRU评分)</span>',
            field: PG_FORM_DATA['意识评估'].id,
            data: PG_FORM_DATA['意识评估'].data
        },
        {label: '预检分级', field: PG_FORM_DATA['预检分级'].id, data: PG_FORM_DATA['预检分级'].data},
        {...getFromPgFormData('创伤')},
        {...getFromPgFormData('疼痛评分')}
    ],
    '气道呼吸系统': [
        {...getFromPgFormData('给氧方式')},
        {...getFromPgFormData('呼吸机模式')},
        {
            label: '呼吸机参数', field: [
                {pre: '潮气量', suf: 'ml', field: 'ventilatorTidalVolume'},
                {pre: '频率', suf: '次/分', field: 'ventilatorFrequency'},
                {pre: '呼吸比', suf: '', field: ['ventilatorInspiratory', 'ventilatorExpiratory'], gutter: '：'},
                {pre: 'PEEP', suf: 'cmH2O', field: 'ventilatorPeep'},
                {pre: '氧浓度', suf: '%', field: 'ventilatorOxygenConcentration'},
                {pre: '气道压力', suf: 'cmH2O', field: 'ventilatorAirwayPressure'}
            ]
        }
    ],
    '急性心肌梗死': [
        {...getFromPgFormData('心电图诊断')},
        {...getFromPgFormData('血液状态监测')},
        {...getFromPgFormData('心血管风险评估')},
        {
            label: '用药', field: [
                {pre: '波立维', suf: 'ml', field: 'medicationPlavix'},
                {pre: '倍林达', suf: 'mg', field: 'medicationBelinda'},
                {pre: '阿司匹林', suf: 'mg', field: 'medicationAspirin'},
                {pre: '立普妥', suf: 'mg', field: 'medicationLipitor'},
                {pre: 'NS', suf: 'ml', field: 'medicationNephroticSyndrome'},
                {pre: '+硝酸甘油', suf: 'mg', field: 'medicationGlycerylTrinitrate'},
                {pre: 'IV-VP', suf: 'ml/h', field: 'medicationIvVp'},
            ]
        }
    ],
    '小儿': [
        {...getFromPgFormData('生长发育评测')},
        {...getFromPgFormData('神经心理发育评测')},
    ],
    '烧伤': [
        {...getFromPgFormData('烧伤程度')}
    ],
    '创伤': [
        {...getFromPgFormData('创伤原因')},
        {
            label: '意识评估<br/><span style="font-size: 12px; color: #999;">(AVRU评分)</span>',
            type: 'mul',
            data: PG_FORM_DATA['c意识评估']
        },
        {label: '创伤评估', type: 'mul', data: PG_FORM_DATA['创伤评估']},
        {...getFromPgFormData('输血信息')}
    ],
    '卒中': [...PG_FORM_DATA['NIHSS'].map(r => {
        return {
            label: r.value,
            field: r.id,
            data: r.data
        }
    }),
        {
            label: '用药', field: [
                {pre: 'RT-PA共', suf: 'mg', field: 'medicationRtPa'},
                {pre: '，1分钟内推入总计量为', suf: 'mg，余下的液体微泵维持1小时', field: 'totalDoseInOneMinute'},
            ]
        }
    ],
    //受伤时间
    '受伤时间': [{...getFromPgFormData('受伤时间')}],
    'NIHSS': [
        {label: '', field: 'nihssScoringRiskAssessment'}
    ]
}

function getFromPgFormData(key) {
    let {id, data = [], extra = []} = PG_FORM_DATA[key] || {};
    return {
        label: key,
        field: id,
        data: data,
        extra: extra.map(r => {
            return {...r};
        })
    }
}

/**
 *  原始input数据
 * @type {{vitalSignsSpo2: {pre: string, min: number, suf: string, max: number, class: string}, vitalSignsTemperature: {pre: string, min: number, suf: string, max: number, class: string}, vitalSignsBloodPressureLower: {pre: string, min: number, suf: string, max: number, class: string}, vitalSignsBloodPressureUpper: {pre: string, min: number, max: number, class: string}, vitalSignsRespire: {pre: string, min: number, suf: string, max: number, class: string}, vitalSignsHeartRate: {pre: string, min: number, suf: string, max: number, class: string}}}
 */
export const originFormData = {
    //生命体征
    vitalSignsBloodPressureUpper: {
        pre: "BP", max: 300, min: 0, class: ''
    },
    vitalSignsBloodPressureLower: {
        pre: '/', suf: 'mmhg', max: 200, min: 0, class: 'mr20'
    },
    vitalSignsHeartRate: {
        pre: "HR", suf: '次/分', class: 'mr20', max: 400, min: 0
    },
    vitalSignsSpo2: {
        pre: 'SpO2', suf: '%', class: 'mr20', max: 100, min: 0
    },
    vitalSignsRespire: {
        pre: 'R', suf: '次/分', class: 'mr20', max: 100, min: 0
    },
    vitalSignsTemperature: {
        pre: "T", suf: '℃', class: '', max: 45, min: 0, float: 1
    },
    //呼吸机参数
    ventilatorTidalVolume: {
        pre: '潮气量', suf: 'ml', max: 1000, min: 0, class: 'mr20'
    },
    ventilatorFrequency: {
        pre: '频率', suf: '次/分', max: 100, min: 0, class: 'mr20'
    },
    ventilatorInspiratory: {
        pre: '呼吸比', suf: '', max: 2, min: 1, class: '', float: 1
    },
    ventilatorExpiratory: {
        pre: ':', suf: '', max: 3, min: 1, class: 'mr20', float: 1
    },
    ventilatorPeep: {
        pre: 'PEEP', suf: 'cmH2O', max: 30, min: 0, class: 'mr20'
    },
    ventilatorOxygenConcentration: {
        pre: 'cmH2O', suf: '%', max: 100, min: 0, class: 'mr20'
    },
    ventilatorAirwayPressure: {
        pre: '气道压力', suf: 'cmH2O', max: 50, min: 0, class: ''
    },
    //急性心肌梗死'medicationPlavix','medicationBelinda','medicationAspirin','medicationLipitor','medicationNephroticSyndrome','medicationGlycerylTrinitrate','medicationIvVp'
    medicationPlavix: {
        pre: '波立维', suf: 'ml', max: 500, min: 0, class: 'mr20'
    },
    medicationBelinda: {
        pre: '倍林达', suf: 'mg', max: 500, min: 0, class: 'mr20'
    },
    medicationAspirin: {
        pre: '阿司匹林', suf: 'mg', max: 500, min: 0, class: 'mr20'
    },
    medicationLipitor: {
        pre: '立普妥', suf: 'mg', max: 500, min: 0, class: 'mr20'
    },
    medicationNephroticSyndrome: {
        pre: 'NS', suf: 'ml', max: 500, min: 0, class: 'mr20'
    },
    medicationGlycerylTrinitrate: {
        pre: '+硝酸甘油', suf: 'mg', max: 500, min: 0, class: 'mr20'
    },
    medicationIvVp: {
        pre: 'IV-VP', suf: 'ml/h', max: 500, min: 0, class: ''
    },
    //烧伤
    degreeOfBurnTrauma: {
        inputClass: 'w300', length: 20
    },
    // 卒中
    medicationRtPa: {
        pre: 'RT-PA共', suf: 'mg', max: 500, min: 0
    },
    totalDoseInOneMinute: {
        pre: '，1分钟内推入总计量为', suf: 'mg，余下的液体微泵维持1小时', max: 500, min: 0
    },
    // 受伤世间
    injuryTime: {
        inputClass: 'w300', pre: '受伤时间：'
    }
}


function originMap(r) {
    return {
        id: r,
        ...originFormData[r]
    }
}

/**
 * 预检评估系统
 * @type {*[]}
 */
export const yjpgxtForm = [
    {
        label: 'a.生命体征',
        type: 'inputGroup',
        value: ['vitalSignsBloodPressureUpper', 'vitalSignsBloodPressureLower', 'vitalSignsHeartRate', 'vitalSignsSpo2', 'vitalSignsRespire', 'vitalSignsTemperature'].map(originMap)
    },
    {
        label: 'b.意识评估',
        id: 'awarenessAssessment',
        type: 'radioGroup',
        value: ['A反应敏捷', 'V对声音刺激有反应', 'P对疼痛刺激有反应', 'U无意识']
    },
    {
        label: 'c.预检分级',
        id: 'preInspectionClassification',
        type: 'radioGroup',
        value: ['I级', 'II级', 'III级', 'IVa级', 'IVb级']
    },
    {
        label: 'd.创伤',
        id: 'trauma',
        type: 'radioGroup',
        value: ['是', '否']
    },
    {
        label: 'e.疼痛评分',
        id: 'painScore',
        type: 'radioGroup',
        value: ['无痛', '有点痛', '轻微疼痛', '疼痛明显', '疼痛严重', '剧烈痛']
    }
]

/**
 * 气道/呼吸系统
 * @type {*[]}
 */
export const qdhxxtForm = [
    {
        label: 'a.给氧方式',
        id: 'provisionsMode',
        type: 'radioGroup',
        value: ['鼻塞', '面罩', '储氧面罩', '气切面罩', '套管内', {
            pre: '',
            label: '呼吸皮囊辅助呼吸',
            suf: 'L/min',
            width: '60px',
            id: 'provisionsModeSupplement'
        }]
    },
    {
        label: 'b.呼吸机模式',
        id: 'ventilatorMode',
        type: 'radioGroup',
        value: ['IPPV/AC', 'SIMV', 'BIPAP', 'PSV/PASB', '无创']
    },
    {
        label: 'c.呼吸机参数',
        type: 'inputGroup',
        value: ['ventilatorTidalVolume', 'ventilatorFrequency', 'ventilatorInspiratory', 'ventilatorExpiratory', 'ventilatorPeep', 'ventilatorOxygenConcentration', 'ventilatorAirwayPressure'].map(originMap)
    }
]

/**
 * 急性心肌梗死
 * @type {*[]}
 */
export const jxxjgsForm = [
    {
        label: 'a.心电图诊断',
        type: 'diy',
        value: [
            {
                id: 'electrocardiogramDiagnosis',
                type: 'checkboxGroup',
                value: ['正常心电图', '房早', '室早', '房颤', '房扑', '室颤', '室上速', '室速', '房室传导阻滞'],
            },
            {
                type: 'radioGroup',
                id: 'atrioventricularBlock',
                value: ['Ⅰ°', 'Ⅱ°', 'Ⅲ°']
            },
            {
                type: 'checkboxGroup',
                id: 'electrocardiogramDiagnosis',
                value: [{
                    pre: '',
                    label: '其他',
                    value: 9,
                    suf: '',
                    width: '400px',
                    id: 'electrocardiogramDiagnosisSupplement'
                }]
            }
        ]
    },
    {
        label: 'b.血液状态监测',
        id: 'bloodConditionMonitoring',
        value: [
            {label: '心肌酶谱', id: 'myocardialZymogramAvatar', value: 0},
            {label: '心肺五项联检', id: 'heartLungPentathlonAvatar', value: 1},
            {label: '床旁血气分析', id: 'bedsideBloodGasAnalysisAvatar', value: 2}],
        type: 'checkboxGroupPic'
    },
    {
        label: 'c.心血管风险评估',
        type: 'checkboxGroup',
        id: 'cardiovascularRiskAssessment',
        value: ['收缩压≥180mmhg', '舒张压≥110mmhg', '吸烟≥30支/天']
    },
    {
        label: 'd.用药',
        type: 'inputGroup',
        value: ['medicationPlavix', 'medicationBelinda', 'medicationAspirin', 'medicationLipitor', 'medicationNephroticSyndrome', 'medicationGlycerylTrinitrate', 'medicationIvVp'].map(originMap)
    }
]
/**
 * 小儿
 * @type {*[]}
 */
export const xeForm = [
    {
        label: 'a.生长发育评测',
        id: 'growthAndDevelopmentEvaluation',
        type: 'radioGroup',
        value: ['胎儿期', '新生儿期', '婴儿期', '幼儿期', '学龄前期', '学龄期', '青春期']
    },
    {
        label: 'b.神经心理发育评测',
        id: 'neuropsychologicalDevelopmentAssessment',
        type: 'radioGroup',
        value: ['感知', '运动', '语言']
    },
]

/**
 * 烧伤
 * @type {*[]}
 */
export const ssForm = [
    {
        label: 'a.烧伤程度',
        id: 'degreeOfBurn',
        type: 'radioGroup',
        value: ['轻度烧伤（Ⅱ°面积＜9%）', '中度烧伤（Ⅱ°面积为10%~29%或Ⅲ°面积不足10%）', '重度烧伤（总烧伤面积达30%~49%或Ⅲ°面积达10%~19%）', '特重烧伤（总烧伤面积＞50%或Ⅲ°＞20%）']
    },
    {
        label: 'b.烧伤原因',
        type: 'inputGroup',
        value: ['degreeOfBurnTrauma'].map(originMap)
    }
]
/**
 * 创伤
 * @type {*[]}
 */
export const csForm = [
    {
        id: '',
        label: 'a.创伤原因',
        type: 'diy',
        value: [
            {
                id: 'causesOfTrauma',
                type: 'checkboxGroup',
                value: ['高处坠落', '交通事故', '重物压伤', '机器搅伤', '刀刺伤', '躯干穿透伤', {
                    pre: '',
                    label: '其他',
                    value: 6,
                    suf: '',
                    width: '400px',
                    id: 'causesOfTraumaSupplement'
                }]
            },
            {
                label: '受伤时间',
                type: 'inputGroup',
                value: ['injuryTime'].map(originMap)
            }
        ],
    },
    {
        label: 'b.意识评估(GCS评分)',
        type: 'radioGroupArray',
        value: [
            {id: 'eyesOpen', label: '睁眼反应', value: ['4自主', '3声音刺激', '2疼痛刺激', '1无']},
            {id: 'speechResponse', label: '言语反应', value: ['5定向良好', '4嗜睡', '3答非所问', '2不能理解', '1无']}, {
                id: 'activityResponse', label: '活动反应',
                value: ['6活动自如', '5定位疼痛', '4躲避疼痛', '3痛刺激屈曲', '2痛刺激伸张', '1无']
            },
        ]
    },
    {
        label: 'c.创伤评估',
        type: 'radioGroupArray',
        value: [
            {id: 'traumaAssessmentAirway', label: '气道', value: ['通畅', '不通畅']},
            {
                id: 'traumaAssessmentBreathing',
                label: '呼吸',
                type: 'checkboxGroup',
                value: ['正常', '急促', '费力', '表浅', '喘息', '无']
            },
            {id: 'traumaAssessmentLoop', label: '循环', value: ['颈动脉搏动可触及', '颈动脉搏动']},
            {id: 'traumaAssessmentHead', label: '头', type: 'checkboxGroup', value: ['正常', '挫裂伤', '其它']},
            {id: 'traumaAssessmentNeck', label: '颈', type: 'checkboxGroup', value: ['正常', '疼痛', '其它']}, {
                id: 'traumaAssessmentChest', label: '胸', type: 'checkboxGroup',
                value: ['正常', '膨胀', '对称', '不对称', '肺呼吸音正常', '肺呼吸音不正常', '肿胀', '皮下气肿', '疼痛', '其它']
            }, {
                id: 'traumaAssessmentAbdomen',
                label: '腹部',
                type: 'checkboxGroup',
                value: ['正常', '膨胀', '疼痛', '肿胀', '其它']
            }, {
                id: 'traumaAssessmentPelvis', label: '骨盆', type: 'checkboxGroup',
                value: ['正常', '稳定', '不稳定', '疼痛', '肿胀', '可见出血', '其他']
            }, {
                id: 'traumaAssessmentMuscleAndBone',
                label: '肌肉与骨骼', type: 'checkboxGroup',
                value: ['正常', '膨胀', '畸形', '无力', '麻木', '其他']
            }, {
                id: 'traumaAssessmentBack',
                label: '后背',
                type: 'checkboxGroup',
                value: ['正常', '肿胀', '疼痛', '其它']
            },
        ],
    },
    {
        label: 'd.输血信息',
        id: 'transfusionInformation',
        type: 'checkboxGroup',
        value: ['红细胞', '血浆', '血小板', '洗涤红细胞', '全血'].map((r, i) => {
            return {
                label: r,
                value: i,
                suf: 'ml',
                max: 9999,
                min: 0,
                id: ['redBloodCellMl', 'plasmaMl', 'plateletMl', 'washedRedBloodCellsMl', 'wholeBloodMl'][i]
            }
        })
    }
]

/**
 * 卒中
 * @type {({data: [string, string, string, string], id: string, value: string}|{data: [string, string, string], id: string, value: string}|{data: [string, string, string], id: string, value: string}|{data: [string, string, string], id: string, value: string}|{data: [string, string, string, string], id: string, value: string})[]}
 */
export const zzForm = [{
    id: 'levelOfConsciousness',
    label: '意识水平',
    type: 'radioGroup',
    value: ['0=清醒，反应敏锐', '1=嗜睡', '2=昏睡或反应迟钝', '3=仅有反射活动或自发反应，或完全没反应']
}, {
    id: 'awarenessLevelQuestioning', label: '意识水平提问',
    type: 'radioGroup',
    value: ['0=都准确', '1=正确回答一个', '2=两个都不准确']
}, {
    id: 'consciousnessLevelInstruction',
    type: 'radioGroup',
    label: '意识水平指令',
    value: ['0=都准确', '1=正确回答一个', '2=两个都不准确']
}, {
    id: 'gaze', label: '注视', type: 'radioGroup',
    value: ['0=正常', '1=部分凝视麻痹', '2=被动凝视或完全凝视麻痹']
}, {
    id: 'emergencyView',
    type: 'radioGroup',
    label: '视野',
    value: ['0=无视野缺失', '1=部分盲', '2=完全偏盲', '3=双侧偏盲']
}, {
    id: 'facialParalysis', label: '面瘫', type: 'radioGroup',
    value: ['0=正常', '1=轻度偏瘫', '2=部分', '3=完全']
}, {
    id: 'upperLimbMovement', label: '上肢运动', type: 'radioGroup',
    value: ['0=上肢要求位置坚持10秒，无下落', '1=上肢能抬起，但不能维持10秒，下落时不能撞击床或其他支持物', '2=能对抗一些重力，但升值不能达到或维持作为90°，或位仰45°，轻快下落', '3=不能对抗中路，上肢快速下落', '4=无运动']
}, {
    id: 'lowerLimbMovement', label: '下肢运动', type: 'radioGroup',
    value: ['0=于要求位置坚持5秒，不下降', '1=在5秒下落，不撞击床', '2=5秒内轻快下落到床上，但可部分抗重力', '3=快速落下，不能抗重力', '4=无运动']
}, {
    id: 'totalMaladjustment',
    label: '共计失调',
    type: 'radioGroup',
    value: ['0=没有', '1=一个肢体有', '2=两个肢体有']
}, {
    id: 'feel', label: '感觉', type: 'radioGroup',
    value: ['0=正常', '1=轻到中度', '2=严重到完全感觉丧失']
}, {
    id: 'emergencyLanguage',
    type: 'radioGroup',
    label: '语言',
    value: ['0=正常', '1=轻到中度', '2=严重失语', '3=缄默或完全失语']
}, {
    id: 'dysarthria', label: '构音障碍', type: 'radioGroup',
    value: ['0=正常', '1=轻到中度', '2=重度，难以理解', '其他=气管插管或其他物理障碍']
}, {
    id: 'neglect',
    label: '忽视症',
    type: 'radioGroup',
    value: ['0=没有', '1=视、触、听、空间觉或对个人的忽视', '2=严重的偏身忽视']
}, {
    id: 'ultrasonicDopplerBlood', type: 'radioGroup',
    label: '超声多普勒血流速度检测',
    value: ['正常', '不正常']
}, {
    label: '用药',
    type: 'inputGroup',
    value: ['medicationRtPa', 'totalDoseInOneMinute'].map(originMap)
}]

/**
 * 用状态机处理流程描述
 */
export function handlerProcedureDescribtion(procedureDescribtion, status) {
    let str = '';
    let state = 0; // 0-普通,1-[,2-]
    const res = [];
    for (let i = 0; i < procedureDescribtion.length; i++) {
        let char = procedureDescribtion[i];
        if (char === '[' && state === 0) {
            state = 1;
            handlerChar();
            str = '';
        } else if (char === ']' && state === 1) {
            state = 2;
            handlerChar();
            str = '';
            state = 0;
        } else {
            str += char;
        }
    }

    if (str) handlerChar();
    Log("procedureDescribtion", res);
    return res.map(r => {
        if (r.type === 'normal') return `<span class="color_777">${r.str}</span>`;
        if (r.type === 'special') return `<span class="${status === 'error' ? 'color_red' : 'color_main'}">${r.str}</span>`;
    }).join('');


    function handlerChar() {
        if (!str) return;
        if (state === 1 || state === 0) {
            res.push({
                str,
                type: 'normal'
            })
        }
        if (state === 2) {
            res.push({
                str,
                type: 'special'
            })
        }
    }
}
